export default __webpack_public_path__ + "static/media/match2.494393bd.jpg";